import { render, staticRenderFns } from "./filtered-dispatches.vue?vue&type=template&id=ced5b6a0"
import script from "./filtered-dispatches.vue?vue&type=script&lang=js"
export * from "./filtered-dispatches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports